import { Box } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import i18n from 'modules/core/lib/i18n'

import DocumentUploader from 'modules/documents/components/Documents/DocumentUploader'
import FolderCustomFields from 'modules/documents/components/FolderCustomFields'
import type Document from 'modules/documents/store/models/Document'
import type DocumentForm from 'modules/timeoff/lib/DocumentForm'
import type LeaveType from 'modules/timeoff/store/models/LeaveType'

import DocumentList from './List'

interface Props {
  documentForm: DocumentForm
  customFieldsForms: Form[]
  leaveType: LeaveType | null | undefined
  onDocumentDropped?: () => void
  canManageLeaveDocuments: boolean
  leaveDocuments: Document[]
  currency?: string
}

const Documents = ({
  documentForm,
  customFieldsForms,
  leaveType,
  onDocumentDropped,
  canManageLeaveDocuments,
  leaveDocuments,
  currency,
}: Props) => {
  const customFieldRender = () => {
    if (documentForm.get('file').value === '') {
      return null
    }

    return (
      <Box paddingTop="s24">
        <FolderCustomFields
          customFieldsForms={customFieldsForms}
          title={i18n.t('time_off.custom_fields.title')}
          description={i18n.t('time_off.custom_fields.description')}
          currency={currency}
        />
      </Box>
    )
  }

  const placeholder = () => {
    if (!leaveType) return i18n.t('time_off.leave_document')

    return leaveType && leaveType.attributes.is_attachment_mandatory
      ? i18n.t('time_off.leave_document_mandatory')
      : i18n.t('time_off.leave_document')
  }

  return (
    <FormRow>
      {/* TODO: it would be nice if this can be refactored to use GraphQL */}
      <DocumentList readonly={!canManageLeaveDocuments} leaveDocuments={leaveDocuments} />
      <DocumentUploader
        readonly={!canManageLeaveDocuments}
        field={documentForm.get('file')}
        placeholder={placeholder()}
        customFieldsRender={customFieldRender}
        onDropped={onDocumentDropped}
      />
    </FormRow>
  )
}

export default observer(Documents)
